export const colorsFoundation = {
    key: {
        gold: {
            50: '#f5f3ec',
            100: '#ede6d4',
            200: '#e6dbba',
            300: '#d7c693',
            400: '#b5a264',
            500: '#9a8440',
            600: '#86702c',
            700: '#7b6521',
            800: '#69530f',
            900: '#5d4705'
        },
        blue: {
            50: '#dcdfe6',
            100: '#c1c7d6',
            200: '#98a2bc',
            300: '#6f7b9c',
            400: '#4f628e',
            500: '#3e5083',
            600: '#283967',
            700: '#1d2b50',
            800: '#111a30',
            900: '#090d18'
        }
    },
    neutral: {
        50: '#f3f3f3',
        100: '#e7e7e6',
        200: '#cfcfce',
        300: '#b7b7b5',
        400: '#9f9f9d',
        500: '#878784',
        600: '#6c6c6a',
        700: '#51514f',
        800: '#363635',
        900: '#1b1b1a',
        softblack: '#1d1d1d',
        white: '#ffffff'
    },
    status: {
        informative: {
            50: '#ecf3ff',
            100: '#cfe2ff',
            200: '#9ec5fe',
            300: '#6ea8fe',
            400: '#3d8bfd',
            500: '#0d6efd',
            600: '#0a58ca',
            700: '#084298',
            800: '#052c65',
            900: '#031633'
        },
        positive: {
            50: '#edffec',
            100: '#ccf9c9',
            200: '#a3f19e',
            300: '#80e07b',
            400: '#50d562',
            500: '#29bc50',
            600: '#16a34a',
            700: '#15803d',
            800: '#166534',
            900: '#14532d'
        },
        critical: {
            50: '#fefce8',
            100: '#fef9c3',
            200: '#fef08a',
            300: '#fde047',
            400: '#facc15',
            500: '#eab308',
            600: '#ca8a04',
            700: '#a16207',
            800: '#854d0e',
            900: '#713f12'
        },
        negative: {
            50: '#fef2f2',
            100: '#f8c2c1',
            200: '#e69797',
            300: '#d77075',
            400: '#b54244',
            500: '#a62532',
            600: '#8d0812',
            700: '#6c0b09',
            800: '#55040b',
            900: '#440107'
        }
    },
    label: {
        purple: '#dddbff',
        grey: '#e7e7e6',
        cyan: '#b0f4f9',
        orange: '#ffe5c9',
        yellow: '#fff8b2',
        blue: '#bcdfff',
        red: '#f8c2c1',
        green: '#c9edbf'
    }
};

export default colorsFoundation;
